import { isSignal, Pipe, PipeTransform, signal, Signal } from '@angular/core';
import { equals } from '@softline/core';
import { ModalOption } from '@softline/ui-core';

@Pipe({
  name: 'optionLabel',
})
export class OptionLabelPipe<T> implements PipeTransform {
  transform(value: T, options: ModalOption<T>[]): Signal<string | null> {
    const selected = options.find(option => equals(option.value, value));

    const label = selected ? selected.label : null;
    if(!label)
      return signal(null);
    if(isSignal(label))
      return label;
    return signal(label);
  }
}
